import React, { memo } from 'react';
import Form from 'react-bootstrap/Form';

import LocationField from './LocationField';

const LocationRow = memo(({
    location, 
    selected, 
    fields,
    locationFilters,
    handleLocationSelect, 
    handleMoveLocationItem,
    handleRemoveLocationItem
    }) => {
    return (
        <tr>
            {handleLocationSelect
                ? <td style={{ width: "2em" }}>
                    <Form.Check
                        id={"item_" + location._id}
                        type="checkbox"
                        checked={selected}
                        onChange={(event) => handleLocationSelect(location._id, event.target.checked)}
                    />
                </td>
                : null
            }

            {fields.filter((field) => field.id !== "customActionsFunction").map((field) => (
                <LocationField
                    key={location._id + "-field-" + field.id}
                    location={location}
                    field={field.id}
                    locationFilters={locationFilters}
                    handleMoveLocationItem={handleMoveLocationItem}
                    handleRemoveLocationItem={handleRemoveLocationItem}
                />
            ))}
        </tr>
    );
}, (prevProps, nextProps) => (
    prevProps.location === nextProps.location
    && prevProps.selected === nextProps.selected
));

export default LocationRow;
